/**
 * @flow
 * @relayHash 09827be89f9f621ae6d8b1ef6b177aad
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type JobsTable_jobEdges$ref = any;
export type JobStatus = "CLOSED" | "OPEN";
export type OrderStatus = "CONFIRMED" | "DELIVERED" | "IN_PRODUCTION" | "READY_FOR_SHIPMENT" | "SHIPPED" | "WAITING_FOR_CONFIRMATION" | "WAITING_FOR_PRODUCTION";
export type UOMType = "LENGTH" | "QUANTITY" | "WEIGHT";
export type AddJobLinkedItemInput = {|
  itemId: string,
  jobId: string,
  usageQty?: ?number,
|};
export type AddJobLinkedItemMutationVariables = {|
  input: AddJobLinkedItemInput
|};
export type AddJobLinkedItemMutationResponse = {|
  +addJobLinkedItem: {|
    +jobEdge: {|
      +node: {|
        +id: string,
        +importJobNumber: ?string,
        +jobNumber: string,
        +name: string,
        +status: JobStatus,
        +linkedItems: {|
          +edges: ?$ReadOnlyArray<?{|
            +usageQty: ?number,
            +node: {|
              +id: string,
              +itemNumber: string,
              +name: string,
              +upc: ?string,
              +partNumber: ?string,
              +description: ?string,
              +category: ?{|
                +id: string,
                +name: string,
              |},
              +quantityUOM: {|
                +id: string,
                +name: string,
                +type: UOMType,
                +symbol: string,
              |},
              +weightUOM: ?{|
                +id: string,
                +name: string,
                +type: UOMType,
                +symbol: string,
              |},
              +dimensionUOM: ?{|
                +id: string,
                +name: string,
                +type: UOMType,
                +symbol: string,
              |},
              +formFieldValues: any,
              +dimensionLength: ?number,
              +dimensionWidth: ?number,
              +dimensionHeight: ?number,
              +weight: ?number,
            |},
          |}>
        |},
        +yields: {|
          +totalCount: number,
          +edges: ?$ReadOnlyArray<?{|
            +node: {|
              +id: string,
              +finalQuantity: number,
            |}
          |}>,
        |},
        +user: ?{|
          +id: string,
          +firstName: string,
          +lastName: string,
        |},
        +order: ?{|
          +id: string,
          +promisedAt: ?any,
          +orderNumber: string,
          +status: OrderStatus,
          +customer: {|
            +id: string,
            +name: string,
          |},
        |},
        +workflow: {|
          +id: string,
          +name: string,
        |},
        +states: $ReadOnlyArray<{|
          +id: string,
          +workflowState: {|
            +id: string,
            +name: string,
          |},
        |}>,
      |},
      +$fragmentRefs: JobsTable_jobEdges$ref,
    |}
  |}
|};
export type AddJobLinkedItemMutation = {|
  variables: AddJobLinkedItemMutationVariables,
  response: AddJobLinkedItemMutationResponse,
|};
*/


/*
mutation AddJobLinkedItemMutation(
  $input: AddJobLinkedItemInput!
) {
  addJobLinkedItem(input: $input) {
    jobEdge {
      ...JobsTable_jobEdges
      node {
        id
        importJobNumber
        jobNumber
        name
        status
        linkedItems {
          edges {
            usageQty
            node {
              id
              itemNumber
              name
              upc
              partNumber
              description
              category {
                id
                name
              }
              quantityUOM {
                id
                name
                type
                symbol
              }
              weightUOM {
                id
                name
                type
                symbol
              }
              dimensionUOM {
                id
                name
                type
                symbol
              }
              formFieldValues
              dimensionLength
              dimensionWidth
              dimensionHeight
              weight
            }
          }
        }
        yields {
          totalCount
          edges {
            node {
              id
              finalQuantity
            }
          }
        }
        user {
          id
          firstName
          lastName
        }
        order {
          id
          promisedAt
          orderNumber
          status
          customer {
            id
            name
          }
        }
        workflow {
          id
          name
        }
        states {
          id
          workflowState {
            id
            name
          }
        }
      }
    }
  }
}

fragment JobsTable_jobEdges on JobEdge {
  node {
    id
    jobNumber
    importJobNumber
    name
    status
    createdAt
    user {
      id
      ...UserAvatar_user
    }
    yields {
      totalCount
    }
    order {
      id
      promisedAt
      customer {
        id
        name
      }
    }
    states {
      id
      isEnabled
      status
      workflowState {
        id
        name
        type
      }
    }
    workflow {
      id
      states {
        id
        name
        isRequired
        type
      }
      transitions {
        id
        toWorkflowState {
          id
        }
        fromWorkflowState {
          id
        }
      }
    }
    ...AddUpdateJobModal_job
    ...DeleteJobModal_job
  }
}

fragment UserAvatar_user on User {
  id
  avatar
  firstName
}

fragment AddUpdateJobModal_job on Job {
  id
  name
  notes
  user {
    id
  }
  workflow {
    id
    name
    states {
      id
      isGangRun
    }
  }
  order {
    id
  }
  yields {
    edges {
      node {
        id
        quantity
        itemNumberUp
        brokerCustomerOrderNumber
        formFieldValues
        overUnderRule
        overQuantity
        item {
          id
          name
          quantityUOM {
            id
            name
            symbol
          }
        }
      }
    }
  }
}

fragment DeleteJobModal_job on Job {
  id
  name
  order {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddJobLinkedItemInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "importJobNumber",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "jobNumber",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v7 = [
  (v2/*: any*/),
  (v5/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v10 = [
  (v2/*: any*/),
  (v5/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "formFieldValues",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "linkedItems",
  "storageKey": null,
  "args": null,
  "concreteType": "JobLinkedItemConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "JobLinkedItemEdge",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "usageQty",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Item",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "itemNumber",
              "args": null,
              "storageKey": null
            },
            (v5/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "upc",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "partNumber",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "description",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "category",
              "storageKey": null,
              "args": null,
              "concreteType": "ItemCategory",
              "plural": false,
              "selections": (v7/*: any*/)
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "quantityUOM",
              "storageKey": null,
              "args": null,
              "concreteType": "UOM",
              "plural": false,
              "selections": (v10/*: any*/)
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "weightUOM",
              "storageKey": null,
              "args": null,
              "concreteType": "UOM",
              "plural": false,
              "selections": (v10/*: any*/)
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "dimensionUOM",
              "storageKey": null,
              "args": null,
              "concreteType": "UOM",
              "plural": false,
              "selections": (v10/*: any*/)
            },
            (v11/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "dimensionLength",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "dimensionWidth",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "dimensionHeight",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "weight",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "finalQuantity",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "promisedAt",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "orderNumber",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "customer",
  "storageKey": null,
  "args": null,
  "concreteType": "Customer",
  "plural": false,
  "selections": (v7/*: any*/)
},
v20 = [
  (v2/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddJobLinkedItemMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "addJobLinkedItem",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "AddJobLinkedItemPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "jobEdge",
            "storageKey": null,
            "args": null,
            "concreteType": "JobEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Job",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v12/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "yields",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobYieldConnection",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobYieldEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "JobYield",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v14/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "order",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Order",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v6/*: any*/),
                      (v19/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "workflow",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Workflow",
                    "plural": false,
                    "selections": (v7/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "states",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobState",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "workflowState",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WorkflowState",
                        "plural": false,
                        "selections": (v7/*: any*/)
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "FragmentSpread",
                "name": "JobsTable_jobEdges",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "AddJobLinkedItemMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "addJobLinkedItem",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "AddJobLinkedItemPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "jobEdge",
            "storageKey": null,
            "args": null,
            "concreteType": "JobEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Job",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v3/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "createdAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "avatar",
                        "args": null,
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      (v16/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "yields",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobYieldConnection",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobYieldEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "JobYield",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "quantity",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "itemNumberUp",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "brokerCustomerOrderNumber",
                                "args": null,
                                "storageKey": null
                              },
                              (v11/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "overUnderRule",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "overQuantity",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "quantityUOM",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UOM",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v5/*: any*/),
                                      (v9/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v14/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "order",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Order",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v17/*: any*/),
                      (v19/*: any*/),
                      (v18/*: any*/),
                      (v6/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "states",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobState",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isEnabled",
                        "args": null,
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "workflowState",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WorkflowState",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v5/*: any*/),
                          (v8/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "workflow",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Workflow",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "states",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WorkflowState",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isGangRun",
                            "args": null,
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isRequired",
                            "args": null,
                            "storageKey": null
                          },
                          (v8/*: any*/)
                        ]
                      },
                      (v5/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "transitions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WorkflowTransition",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "toWorkflowState",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WorkflowState",
                            "plural": false,
                            "selections": (v20/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "fromWorkflowState",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WorkflowState",
                            "plural": false,
                            "selections": (v20/*: any*/)
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "notes",
                    "args": null,
                    "storageKey": null
                  },
                  (v12/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddJobLinkedItemMutation",
    "id": null,
    "text": "mutation AddJobLinkedItemMutation(\n  $input: AddJobLinkedItemInput!\n) {\n  addJobLinkedItem(input: $input) {\n    jobEdge {\n      ...JobsTable_jobEdges\n      node {\n        id\n        importJobNumber\n        jobNumber\n        name\n        status\n        linkedItems {\n          edges {\n            usageQty\n            node {\n              id\n              itemNumber\n              name\n              upc\n              partNumber\n              description\n              category {\n                id\n                name\n              }\n              quantityUOM {\n                id\n                name\n                type\n                symbol\n              }\n              weightUOM {\n                id\n                name\n                type\n                symbol\n              }\n              dimensionUOM {\n                id\n                name\n                type\n                symbol\n              }\n              formFieldValues\n              dimensionLength\n              dimensionWidth\n              dimensionHeight\n              weight\n            }\n          }\n        }\n        yields {\n          totalCount\n          edges {\n            node {\n              id\n              finalQuantity\n            }\n          }\n        }\n        user {\n          id\n          firstName\n          lastName\n        }\n        order {\n          id\n          promisedAt\n          orderNumber\n          status\n          customer {\n            id\n            name\n          }\n        }\n        workflow {\n          id\n          name\n        }\n        states {\n          id\n          workflowState {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment JobsTable_jobEdges on JobEdge {\n  node {\n    id\n    jobNumber\n    importJobNumber\n    name\n    status\n    createdAt\n    user {\n      id\n      ...UserAvatar_user\n    }\n    yields {\n      totalCount\n    }\n    order {\n      id\n      promisedAt\n      customer {\n        id\n        name\n      }\n    }\n    states {\n      id\n      isEnabled\n      status\n      workflowState {\n        id\n        name\n        type\n      }\n    }\n    workflow {\n      id\n      states {\n        id\n        name\n        isRequired\n        type\n      }\n      transitions {\n        id\n        toWorkflowState {\n          id\n        }\n        fromWorkflowState {\n          id\n        }\n      }\n    }\n    ...AddUpdateJobModal_job\n    ...DeleteJobModal_job\n  }\n}\n\nfragment UserAvatar_user on User {\n  id\n  avatar\n  firstName\n}\n\nfragment AddUpdateJobModal_job on Job {\n  id\n  name\n  notes\n  user {\n    id\n  }\n  workflow {\n    id\n    name\n    states {\n      id\n      isGangRun\n    }\n  }\n  order {\n    id\n  }\n  yields {\n    edges {\n      node {\n        id\n        quantity\n        itemNumberUp\n        brokerCustomerOrderNumber\n        formFieldValues\n        overUnderRule\n        overQuantity\n        item {\n          id\n          name\n          quantityUOM {\n            id\n            name\n            symbol\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment DeleteJobModal_job on Job {\n  id\n  name\n  order {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2ee1473ca9d8b3d0da84a25f2cefb2f5';
module.exports = node;
